/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type ConversationCategoryFilterConfigColumn =
  (typeof ConversationCategoryFilterConfigColumn)[keyof typeof ConversationCategoryFilterConfigColumn];

export const ConversationCategoryFilterConfigColumn = {
  conversation_category: 'conversation_category',
} as const;
